import * as Scrivito from "scrivito"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const HomepageObjClass = Scrivito.provideObjClass("Homepage", {
  attributes: {
    body: "widgetlist",
    title: "string",
    navigationTitle: "string",
    siteUrlPrefix: "string"
  },
  extractTextAttributes: ["title", "body"],
  onlyAsRoot: true
})

export type Homepage = InstanceType<typeof HomepageObjClass>
export type HomepageAttributes = ScrivitoAttributes<Homepage>
